import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'productShopPanel',
    serviceName: 'grapghql',
    query: gql`
      query productShopPanel($ids: [String], $for_admin: Int) {
        productShopPanel(ids: $ids, for_admin: $for_admin) {
          data {
            id
            stock
            co_price
            me_price
            is_active
            max_number_buy
            nonexistent_number
            shop {
              id
            }
            booth {
              id
            }
            product_info {
              id
              title
              barcode
              introtext
              brand {
                id
              }
              category {
                id
              }
              packaged_items {
                me_price
                quantity
                product_shop {
                  id
                }
              }
            }
          }
        }
      }
    `,
  },
  update: {
    name: 'updateProductPackagedItemTotality',
    serviceName: 'shopadmin',
    query: gql`
      mutation updateProductPackagedItemTotality(
        $product_id: String!
        $product_shop_id: String!
        $title: String!
        $shop_id: String!
        $booth_id: String!
        $brand_id: String
        $category_id: String
        $co_price: String
        $me_price: String
        $stock: String
        $max_number_buy: String
        $nonexistent_number: String
        $discount_value: String
        $is_active: Int
        $introtext: String
        $packaged_items: [PackagedItemInput]!
        $barcode: String
      ) {
        updateProductPackagedItemTotality(
          product_id: $product_id
          product_shop_id: $product_shop_id
          title: $title
          shop_id: $shop_id
          booth_id: $booth_id
          brand_id: $brand_id
          category_id: $category_id
          co_price: $co_price
          me_price: $me_price
          stock: $stock
          max_number_buy: $max_number_buy
          nonexistent_number: $nonexistent_number
          discount_value: $discount_value
          is_active: $is_active
          introtext: $introtext
          packaged_items: $packaged_items
          barcode: $barcode
        ) {
          influenced_count
          messages
        }
      }
    `,
  },
};

export default schema;
